import React from "react";
import { ReactComponent as RetentionIcon } from "../../../Assets/icon-retention-alt.svg";
import { ReactComponent as NewBuisnessIcon } from "../../../Assets/icon-newbuisness.svg";

const StoryIcon = ({ storyType }) => (
    storyType?.toLowerCase()?.replace("v2", "") === "lapse" ? <RetentionIcon/> : <NewBuisnessIcon/>
)

export default StoryIcon